import PropTypes from 'prop-types';
import styles from './NormalTable.module.css';

const ReusableTable = ({ columns, rows }) => {
    return (
        <div className={styles.tableWrapper}>
            <table className={styles.table}>
                <thead>
                    <tr>
                        {columns.map((col, index) => (
                            <th key={index} className={styles.tableHeader}>
                                {col.label}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {rows.map((row, rowIndex) => (
                        <tr key={rowIndex} className={styles.tableRow}>
                            {columns.map((col, colIndex) => (
                                <td key={colIndex} className={styles.tableCell}>
                                    {col.render ? col.render(row) : row[col.field]}
                                </td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default ReusableTable;
ReusableTable.propTypes = {
    columns: PropTypes.array,
    rows: PropTypes.array
};
